module.exports = __webpack_public_path__ + "static/media/IoT-手柄-新.bebe647d.jpg";